const Logo = ({ size = 40 }) => (
  <img
    src="/logo.webp"
    alt="Logo Forty One"
    data-testid="brand-logo"
    style={{ height: size, width: "auto" }}
    className="object-contain"
  />
);

export default Logo;
